module.exports = __webpack_public_path__ + "media/rutin-medium.3a1933c1.mp4";